import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBirdwatchIconAvatar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 128,
	height: 128,
	viewBox: "0 0 128 128",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_83_5288)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M128 0H0V128H128V0Z",
			fill: "#94A3B8",
			fillOpacity: .16
		}), /* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip1_83_5288)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M82.4236 27.8541C77.7459 22.7892 71.212 20 64.0004 20C56.7504 20 50.1951 22.7723 45.5388 27.806C40.8321 32.8949 38.5388 39.8112 39.0771 47.2796C40.1446 62.014 51.3249 74 64.0004 74C76.6761 74 87.8372 62.0162 88.9214 47.2844C89.467 39.8836 87.1592 32.9818 82.4236 27.8541Z",
				fill: "#94A3B8"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M113.942 128C114.107 125.767 113.911 120.928 113.448 118.357C111.435 107.14 105.153 97.7168 95.2792 91.1042C86.5071 85.2344 75.3955 82 63.988 82C52.5806 82 41.4688 85.2322 32.6967 91.1042C22.8228 97.7192 16.5407 107.142 14.5278 118.359C14.0651 120.93 13.9281 126.139 14.0337 128H113.942Z",
				fill: "#94A3B8"
			})]
		})]
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_83_5288",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 128,
			height: 128,
			rx: 24,
			fill: "white"
		})
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip1_83_5288",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 100,
			height: 108,
			fill: "white",
			transform: "translate(14 20)"
		})
	})] })]
});
export default SvgBirdwatchIconAvatar;
